import { SET_OPEN_MODAL_SUBVENCOES } from "../actions/actionTypes";

const INITIAL_STATE = {
    openModalSubvencoes: false
};

// eslintdisablenextline
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_OPEN_MODAL_SUBVENCOES:
            return {
                ...state,
                openModalSubvencoes: action.payload
            };                
        default:
            return state;
    }
};